module.exports = __webpack_public_path__ + "static/media/banner_10.a8a15217.jpg";